import type { MonitorState } from "../Monitor/type";
import { NEWS_CATEGORY, type NewsState } from "../News/types";
import { DEFAULT_STATE } from "../Screener/default";
import type { WidgetScreenerState } from "../Screener/type";

export const newsHeightClass = "h-[288px]";

export const stockScannersState: WidgetScreenerState = {
	panelMode: "Freeze mode",
};

export const earningsCalendarState: WidgetScreenerState = {
	fields: ["ticker", "rt_price_chg.d5", "rs_abs_chg_nasdaq.ed", "act_rpt_code"],
	filter: [
		...(DEFAULT_STATE?.filter ?? []),
		{
			name: "rs_abs_chg_nasdaq.ed",
			condition: "gte",
			value: -1000,
		},
		{
			name: "rs_abs_chg_nasdaq.ed",
			condition: "lte",
			value: 4000,
		},
	],
	sort: [{ name: "market_cap", order: -1 }],
	panelMode: "Freeze mode",
};

export const sectorsGridState: MonitorState = {
	fields: [
		"ticker",
		"name",
		"adj_close_price_line_15d",
		"rt_price",
		"rt_price_chg.d1",
		"rt_price_chg.d5",
		"rt_price_chg.d20",
		"adj_close_pct_chg.YTD",
		"max_dd_xy.1_Y",
		"trend_indicator_final_status",
		"slope_price_momentum_signal",
		"powerday_trend_status",
		"volatility_strength_status",
	],
	tickers: [
		"XLB",
		"XLC",
		"XLE",
		"XLF",
		"XLI",
		"XLK",
		"XLP",
		"XLRE",
		"XLU",
		"XLV",
		"XLY",
	],
	sort: [
		{
			name: "ticker",
			order: 1,
		},
	],
	isDeleteButtonHidden: true,
};

export const benchmarkScreenerGridState: MonitorState = {
	fields: [
		"ticker",
		"name",
		"adj_close_price_line_15d",
		"rt_price",
		"rt_price_chg.d1",
		"rt_price_chg.d5",
		"rt_price_chg.d20",
		"adj_close_pct_chg.YTD",
		"max_dd_xy.1_Y",
		"trend_indicator_final_status",
		"slope_price_momentum_signal",
		"powerday_trend_status",
		"volatility_strength_status",
	],
	tickers: [
		"SPY",
		"QQQ",
		"DIA",
		"IWM",
		"GLD",
		"IBIT",
		"USO",
		"VGK",
		"EWG",
		"EWU",
		"INDA",
		"EWS",
		"EWH",
		"CNYA",
		"EWJ",
		"EWA",
	],
	isDeleteButtonHidden: true,
};

export const generalNewsState: NewsState = {
	columnOrder: ["publication_date", "title"],
	filter: [
		{
			name: "datasource",
			condition: "in",
			value: ["finalle", "fmp"],
		},
		{
			name: "dataset",
			condition: "in",
			value: ["general_news", "events"],
		},
	],
	pagination: {
		limit: 15,
		offset: 0,
	},
};

export const earningsNewsState: NewsState = {
	columnOrder: ["publication_date", "estimate", "ticker", "title"],
	categoryFilters: [NEWS_CATEGORY.EARNINGS],
	pagination: {
		limit: 15,
		offset: 0,
	},
};

export const transcriptsNewsState: NewsState = {
	columnOrder: ["publication_date", "ticker", "title"],
	categoryFilters: [NEWS_CATEGORY.TRANSCRIPTS],
	pagination: {
		limit: 15,
		offset: 0,
	},
};
